import { render, staticRenderFns } from "./MyActivity.vue?vue&type=template&id=f24166a2"
import script from "./MyActivity.vue?vue&type=script&lang=js"
export * from "./MyActivity.vue?vue&type=script&lang=js"
import style0 from "./MyActivity.vue?vue&type=style&index=0&id=f24166a2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports